import i18n from "../i18n";

const getUserRole = () => {
    try {
        const users = JSON.parse(localStorage.getItem("users") || "{}");
        return users?.user?.role || "user";
    } catch { return "user"; }
};

// Features liberadas pro usuário (marketplace/maintenance). Enquanto o bootstrap
// não popula users.user.features, retorna null → os itens aparecem pra todos e
// a própria página trata o 403. Quando features estiver presente, gateia.
const getUserFeatures = () => {
    try {
        const users = JSON.parse(localStorage.getItem("users") || "{}");
        const f = users?.user?.features;
        return Array.isArray(f) ? f : null;
    } catch { return null; }
};
const hasFeature = (key) => {
    const f = getUserFeatures();
    return f === null || f.includes(key);
};

export const buildMenuItems = () => {
    const t = (key) => i18n.t(key);
    // Menu enxuto do Oplena (prestação de serviço): início, clientes, boletos, help desk.
    return [
        { label: "MENU", isHeader: true },
        { id: "inicio", label: t("Início"), icon: "fa-solid fa-house", link: "/admin/dashboard" },
        { id: "clientes", label: t("Clientes"), icon: "fa-solid fa-users", link: "/admin/clientes" },
        { id: "contatos", label: t("Contatos"), icon: "fa-solid fa-envelope-open-text", link: "/admin/contatos" },
        { id: "boletos", label: t("Boletos"), icon: "fa-solid fa-file-invoice-dollar", link: "/admin/boletos" },
        { id: "helpdesk", label: t("Help Desk"), icon: "fa-solid fa-headset", link: "/admin/helpdesk" },
    ];
};

// Do NOT cache — always call buildMenuItems() to get current language
export const menuItems = buildMenuItems();
